module.exports = __webpack_public_path__ + "static/media/jim.d6c5a331.jpg";